import { render, staticRenderFns } from "./AbaEditarItensDi.vue?vue&type=template&id=d6af198a"
import script from "./AbaEditarItensDi.vue?vue&type=script&lang=ts"
export * from "./AbaEditarItensDi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports